import React from "react";
import { Container, Row } from "react-bootstrap";
import LoginFrom from "../LoginForm";

const LoginPage = () => {
  return <LoginFrom />;
};

export default LoginPage;
